<div class="divisor20"></div>
<div>
    <div class="row">
        <div class="col-lg-9 col-md-8 col-sm-6 col-12">
            <!-- Generales -->
            <div class="row">
                <div class="col-12">
                    <span class="labelDescripcionGris">{{'Generales'}}</span>
                </div>
            </div>
            <div class="divisor20"></div>
            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'Nombre'" [(ngModel)]="entidad.nombre" [capitalize]="formato == 2" [uppercase]="formato == 1" [errorActivo]="errorActivo"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'Ap. paterno'" [(ngModel)]="entidad.apellidopaterno" [capitalize]="formato == 2" [uppercase]="formato == 1" [errorActivo]="errorActivo"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'Ap. materno'" [(ngModel)]="entidad.apellidomaterno" [capitalize]="formato == 2" [uppercase]="formato == 1" [errorActivo]="errorActivo"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12" *ngIf="configuracionDatePicker">
                    <datePickerV2Custom [disabled]="disabled" [titulo]="'Fecha de nacimiento'" [(ngModel)]="entidad.fechanacimiento" [verError]="false" [addConfiguracion]="configuracionDatePicker"></datePickerV2Custom>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'RFC'" [(ngModel)]="entidad.rfc" [errorActivo]="errorActivo" [uppercase]="true" [pattern]="sistemaService.RFCFisicaER"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'CURP'" [(ngModel)]="entidad.curp" [errorActivo]="errorActivo" [uppercase]="true" [pattern]="sistemaService.CURPER" [verError]="entidad.curp.trim() ? true:false"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'N° nómina'" [(ngModel)]="entidad.nomina" [errorActivo]="errorActivo" [mask]="sistemaService.numeroEnteroMask"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <dropdownCustom [disabled]="disabled" [titulo]="'Género'"
                        [(ngModel)]="entidad.genero"
                        [opciones]="SelGenero"
                        [valorName]="'valor'"
                        [displayValor]="'nombre'"
                        [buscar]="false"
                        ></dropdownCustom>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <dropdownCustom [disabled]="disabled" [titulo]="'Estado civil'"
                        [(ngModel)]="entidad.situacionconyugalid"
                        [opciones]="SelSituacionConyugal"
                        [valorName]="'situacionconyugalid'"
                        [displayValor]="'descripcion'"
                        [buscar]="false"
                        [verError]="false"
                        ></dropdownCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <dropdownCustom [disabled]="disabled" [titulo]="'Nacionalidad'"
                        [(ngModel)]="entidad.nacionalidadid"
                        [opciones]="SelNacionalidad"
                        [valorName]="'nacionalidadid'"
                        [displayValor]="'nombre'"
                        [verError]="false"
                        ></dropdownCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'NSS (IMSS)'" [(ngModel)]="entidad.nss" [verError]="false"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <dropdownCustom [disabled]="disabled" [titulo]="'Tipo de sangre'"
                        [(ngModel)]="entidad.tiposanguineoid"
                        [opciones]="SelTipoSanguineo"
                        [valorName]="'tiposanguineoid'"
                        [displayValor]="'descripcion'"
                        [buscar]="false"
                        [verError]="false"
                        ></dropdownCustom>
                </div>
            </div>

            <!-- Datos de contacto -->
            <div class="row">
                <div class="col-12">
                    <span class="labelDescripcionGris">{{'Datos de contacto'}}</span>
                </div>
            </div>
            <div class="divisor20"></div>
            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'Teléfono fijo'" [(ngModel)]="entidad.telefonofijo" [errorActivo]="errorActivo" [pattern]="sistemaService.TelefonoER" [mask]="sistemaService.telefonoMask" [verError]="false"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'Teléfono celular'" [(ngModel)]="entidad.telefonocelular" [errorActivo]="errorActivo" [pattern]="sistemaService.TelefonoER" [mask]="sistemaService.telefonoMask"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'Correo personal'" [(ngModel)]="entidad.emailpersonal" [errorActivo]="errorActivo" [pattern]="sistemaService.CorreoER"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'Correo institucional'" [(ngModel)]="entidad.emailinstitucional" [errorActivo]="errorActivo" [pattern]="sistemaService.CorreoER"></inputCustom>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-lg-3 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'Código postal'" [(ngModel)]="entidad.cp" [errorActivo]="errorActivo" [mask]="sistemaService.numeroEnteroConCeroMask" (ngModelChange)="setDireccion(entidad.cp)" [verError]="false"></inputCustom>
                </div>
                <div class="col-lg-3 col-lg-3 col-sm-6 col-12">
                    <dropdownCustom [disabled]="disabled" [titulo]="'Estado'"
                        [(ngModel)]="entidad.estadoid"
                        (ngModelChange)="setMunicipio(entidad.estadoid)"
                        [opciones]="SelEstado"
                        [valorName]="'estadoid'"
                        [displayValor]="'nombre'"
                        [verError]="false"
                        ></dropdownCustom>
                </div>
                <div class="col-lg-3 col-lg-3 col-sm-6 col-12">
                    <dropdownCustom [disabled]="disabled" [titulo]="'Ciudad'"
                        [(ngModel)]="entidad.municipioid"
                        (ngModelChange)="setColonia(entidad.municipioid)"
                        [opciones]="SelMunicipio"
                        [valorName]="'municipioid'"
                        [displayValor]="'nombre'"
                        [verError]="false"
                        ></dropdownCustom>
                </div>

                <div class="col-lg-3 col-lg-3 col-sm-6 col-12">
                    <dropdownCustom [disabled]="disabled" [titulo]="'Colonia'"
                        [(ngModel)]="entidad.coloniaid"
                        [opciones]="SelColonia"
                        [valorName]="'coloniaid'"
                        [displayValor]="'nombre'"
                        (ngModelChange)="setOtraColonia(entidad.coloniaid)"
                        [verError]="false"
                        ></dropdownCustom>
                </div>

            </div>
            <div class="row">
                <div class="col-lg-3 col-lg-3 col-sm-6 col-12" *ngIf="verotracolonia && SelColonia.length > 0">
                    <inputCustom [disabled]="disabled" [titulo]="'Otra colonia'" [(ngModel)]="entidad.otracolonia" [errorActivo]="errorActivo" [verError]="false"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'Calle'" [(ngModel)]="entidad.calle"  [verError]="false"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'N° exterior'" [(ngModel)]="entidad.numero"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'N° interior'" [(ngModel)]="entidad.numerointerior" [verError]="false"></inputCustom>
                </div>

            </div>
            <div class="row">
                <div class="col-lg-6 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'Nombre completo de contacto de emergencia'" [(ngModel)]="entidad.nombrecontacto" [capitalize]="formato == 2" [uppercase]="formato == 1" [verError]="false"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled" [titulo]="'Celular contacto'" [(ngModel)]="entidad.telefonocontacto" [verError]="false" [pattern]="sistemaService.TelefonoER" [mask]="sistemaService.telefonoMask"></inputCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <dropdownCustom [disabled]="disabled" [titulo]="'Parentesco del contacto'"
                        [(ngModel)]="entidad.parentescoid"
                        [opciones]="SelParentesco"
                        [valorName]="'parentescoid'"
                        [displayValor]="'descripcion'"
                        [verError]="false"
                        ></dropdownCustom>
                </div>
            </div>

            <!-- Datos del colaborador -->
            <div class="row">
                <div class="col-12">
                    <span class="labelDescripcionGris">{{'Datos del colaborador'}}</span>
                </div>
            </div>
            <div class="divisor20"></div>
            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <dropdownCustom [disabled]="disabled" [titulo]="'Tipos de colaborador'"
                        [(ngModel)]="entidad.tipocolaboradorid"
                        (ngModelChange)="setDatosAcademicos(entidad.tipocolaboradorid)"
                        [opciones]="SelTipoColaborador"
                        [valorName]="'tipocolaboradorid'"
                        [displayValor]="'nombre'"
                        [errorActivo]="errorActivo"
                        [buscar]="false"
                        ></dropdownCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <dropdownCustom [disabled]="disabled" [titulo]="'Estatus de colaborador'"
                        [(ngModel)]="entidad.estatuscolaboradorid"
                        [opciones]="SelEstatusColaborador"
                        [valorName]="'estatuscolaboradorid'"
                        [displayValor]="'nombre'"
                        [errorActivo]="errorActivo"
                        [buscar]="false"
                        ></dropdownCustom>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <inputCustom [disabled]="disabled || id ? true:false" [titulo]="'Usuario de sistema'" [(ngModel)]="entidad.usuario" [errorActivo]="errorActivo"></inputCustom>
                </div>
            </div>


            <!-- Datos para académico -->
            <div class="box" *ngIf="entidad.tipocolaboradorid == 2 || entidad.tipocolaboradorid == 0">
                <div class="row">
                    <div class="col-12">
                        <span class="labelDescripcionGris">{{'Datos para académico'}}</span>
                    </div>
                </div>
                <div class="divisor20"></div>
                <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                        <inputCustom [disabled]="disabled" [titulo]="'Experiencia en el instituto'" [(ngModel)]="entidad.experienciainstituto" [verError]="false" [mask]="sistemaService.numeroDecimalMask"></inputCustom>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                        <datePickerV2Custom [disabled]="disabled" [titulo]="'Experiencia en la SEP'" [(ngModel)]="entidad.experienciasep" [verError]="false"></datePickerV2Custom>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                        <inputCustom [disabled]="disabled" [titulo]="'Autorización DGB'" [(ngModel)]="entidad.autorizaciondgb" [verError]="false"></inputCustom>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                        <inputCustom [disabled]="disabled" [titulo]="'Autorización SEP'" [(ngModel)]="entidad.autorizacionsep" [verError]="false"></inputCustom>
                    </div>
                </div>
            </div>

        </div>

        <div class="col-lg-3 col-md-4 col-sm-6 col-12">
            <!-- Foto -->
            <div class="row">
                <div class="col-12">
                    <span class="labelDescripcionGris">{{'Fotografía'}}</span>
                </div>
            </div>
            <div class="divisor20"></div>
            <div class="row" *ngIf="loaded">
                <div class="col-12" *ngIf="!disabled">
                    <fileCustom [disabled]="disabled" [titulo]="'Foto'" [mimeTypeAceptado]="'image/*'" [fileSave]="entidad.urlfotografia ? true:false" (archivoSeleccionado)="entidad.foto = $event; entidad.urlfotografia = ''"  [verError]="false"></fileCustom>
                </div>
                <div class="col-12" *ngIf="entidad.urlfotografia">
                    <div class="imagenPerfil">
                        <div class="marco">
                            <div class="imagenPanel">
                                <img [src]="entidad.urlfotografia | Imagen | async" id="ImagenPerfil">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="divisor8"></div>
    <div class="row">
        <div class="col-lg-12 col-lg-12 col-sm-12 col-12">
            <!-- Hijos -->
            <div class="row">
                <div class="col-12">
                    <span class="labelDescripcionGris">{{'Hijos del colaborador'}}</span>
                </div>
            </div>

            <div class="divisor20" *ngIf="!disabled"></div>
            <div class="row" *ngIf="!disabled">
                <div class="col-12">
                    <div class="panelBotonesFiltro mixto">
                        <button  class="btn boton botonXS" (click)="AgregarHijo()">
                            <span class="fa fa-plus"></span>
                            <span> {{'Agregar'}}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="divisor16"></div>

            <!-- datos -->
            <dx-data-grid
                id="tabla"
                [columnAutoWidth]="true"
                [dataSource]="dataTable"
                [showColumnHeaders]="true"
                >

                <dxi-column *ngIf="!disabled"
                    [allowExporting]="false"
                    caption="Acciones"
                    cellTemplate="cellAcciones"
                    alignment="center">

                </dxi-column>
                <dxi-column
                    dataField="matricula"
                    caption="Matrícula">
                </dxi-column>
                <dxi-column
                    dataField="nombre"
                    caption="Nombre">
                </dxi-column>
                <dxi-column
                    dataField="apellidopaterno"
                    caption="Ap. paterno">
                </dxi-column>
                <dxi-column
                    dataField="apellidomaterno"
                    caption="Ap. materno">
                </dxi-column>
                <dxi-column
                    dataField="nivel"
                    caption="Nivel">
                </dxi-column>
                <dxi-column
                    dataField="grado"
                    caption="Grado">
                </dxi-column>
                <dxi-column
                    dataField="grupo"
                    caption="Grupo">
                </dxi-column>

                <dxi-column
                    dataField="estatus"
                    caption="Estatus">
                </dxi-column>


                <!-- Acciones -->
                <div *dxTemplate="let cell of 'cellAcciones'">
                    <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="EliminarAlumno(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                    </a>
                </div>

            </dx-data-grid>
        </div>
    </div>
</div>

<alumnomodal #alumno (respuesta)="GuardarHijo($event)"></alumnomodal>
